interface MethodSectionProps {
  onOpenModal: () => void;
}

export default function MethodSection({ onOpenModal }: MethodSectionProps) {
  const steps = [
    {
      number: '1',
      icon: 'ri-radar-line',
      title: 'Atração Inteligente',
      description: 'Campanhas focadas em cliente com intenção real de compra.',
      color: 'orange'
    },
    {
      number: '2',
      icon: 'ri-organization-chart',
      title: 'Organização Estratégica',
      description: 'CRM estruturado para controlar cada oportunidade.',
      color: 'red'
    },
    {
      number: '3',
      icon: 'ri-robot-2-line',
      title: 'Automação de Follow-up',
      description: 'Leads recebem contato no tempo certo, automaticamente.',
      color: 'yellow'
    },
    {
      number: '4',
      icon: 'ri-refresh-line',
      title: 'Recuperação da Base',
      description: 'Clientes antigos voltam a comprar.',
      color: 'green'
    },
    {
      number: '5',
      icon: 'ri-line-chart-line',
      title: 'Otimização Contínua',
      description: 'Métricas claras e decisões baseadas em dados.',
      color: 'orange'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors = {
      orange: 'from-orange-500 to-orange-600',
      red: 'from-red-500 to-red-600',
      yellow: 'from-yellow-500 to-yellow-600',
      green: 'from-green-500 to-green-600'
    };
    return colors[color as keyof typeof colors] || colors.orange;
  };

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="container px-4">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
              Como Funciona <span className="text-orange-600">Na Prática</span>
            </h2>
            <p className="text-lg lg:text-xl text-gray-600">
              Método M4 – Estrutura de Vendas Previsível
            </p>
          </div>
          
          {/* Steps */}
          <div className="space-y-4 mb-12 lg:mb-16">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-xl p-6 lg:p-8 hover:bg-gray-100 transition-all duration-300 group"
              >
                <div className="flex items-start gap-4 lg:gap-6">
                  {/* Number Badge */}
                  <div className={`w-14 h-14 lg:w-16 lg:h-16 bg-gradient-to-br ${getColorClasses(step.color)} rounded-lg flex items-center justify-center flex-shrink-0`}>
                    <span className="text-xl lg:text-2xl font-bold text-white">{step.number}</span>
                  </div>
                  
                  {/* Content */}
                  <div className="flex-1 pt-1">
                    <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-1.5">
                      {step.title}
                    </h3>
                    <p className="text-base lg:text-lg text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* CTA */}
          <div className="text-center">
            <button 
              onClick={onOpenModal}
              className="bg-green-600 hover:bg-green-700 text-white text-base lg:text-lg px-8 lg:px-10 py-3.5 lg:py-4 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-calendar-line"></i>
              AGENDAR REUNIÃO
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
